import React, { FC, useRef, useEffect, useState } from 'react';

import '../../charts/charts.scss';

interface IOptions {
  handleClickOnLegend: (el: string) => void;
  isIncreasedSize: boolean;
  isHiddenLabel: string[];
  isVisiblelabel: string[];
  colorOptions: string[];
  isLabels: string[];
  type: string;
  filters?: any;
};

const ScrollingLegend: FC<IOptions> = ({
  handleClickOnLegend,
  isIncreasedSize,
  isVisiblelabel,
  isHiddenLabel,
  colorOptions,
  isLabels,
  filters,
  type
}) => {
  const legendRef = useRef<HTMLDivElement>(null);

  const [isMiddleMousePressed, setIsMiddleMousePressed] = useState(false);
  const [startY, setStartY] = useState<number>(0);
  const [scrollStart, setScrollStart] = useState<number>(0);

  const scrollStep = 21;
  const typeCircle = type === 'pie' || type === 'doughnut';
  
  const getStatusValues = (key: string): string[] => {
    return filters && filters?.map((status: { value: string, label: string }) => {

      return status.value.toLocaleLowerCase() === key.toLocaleLowerCase() ? status.label : undefined;
    })
      .filter((value: string | undefined) => value !== undefined);
  };

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      if (legendRef.current) {
        event.preventDefault();

        const currentScrollTop = legendRef.current.scrollTop;
        const count = Math.round(currentScrollTop / scrollStep);

        const newScrollTop =
          event.deltaY > 0
            ? (count + 1) * scrollStep
            : (count - 1) * scrollStep;

        legendRef.current.scrollTo({
          top: newScrollTop,
          behavior: 'auto',
        });
      }
    };

    const handleScroll = () => {
      if (legendRef.current) {
        const scrollTop = legendRef.current.scrollTop;
        const roundedScrollTop =
          Math.round(scrollTop / scrollStep) * scrollStep;

        if (Math.abs(scrollTop - roundedScrollTop) <= scrollStep / 2) {
          legendRef.current.scrollTop = roundedScrollTop;
        }
      }
    };

    const legendElement = legendRef.current;

    if (legendElement) {
      legendElement.addEventListener('wheel', handleWheel, {
        passive: false,
      });
      legendElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (legendElement) {
        legendElement.removeEventListener('wheel', handleWheel);
        legendElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const normalizeScroll = () => {
    if (legendRef.current) {
      const scrollTop = legendRef.current.scrollTop;
      const normalized = Math.round(scrollTop / scrollStep) * scrollStep;
      legendRef.current.scrollTop = normalized;
    }
  };

  const handleMouseMove = (event: MouseEvent) => {
    if (isMiddleMousePressed && legendRef.current) {
      const deltaY = event.clientY - startY;
      legendRef.current.scrollTop = scrollStart - deltaY;
    }
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.button === 1) {
      event.preventDefault();
      setIsMiddleMousePressed(true);
      setStartY(event.clientY);
      setScrollStart(legendRef.current?.scrollTop || 0);
    }
  };

  const handleMouseUp = () => {
    if (isMiddleMousePressed) {
      setIsMiddleMousePressed(false);
      normalizeScroll();
    }
  };

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    // eslint-disable-next-line
  }, [isMiddleMousePressed, startY, scrollStart]);

  return (
    <div
      className='charts__legend' style={{ height: `${isIncreasedSize ? '40vh' : '63px'}` }}
      ref={legendRef}
      onMouseDown={handleMouseDown}
    >
      <div className='charts__block'>
        {isLabels.map((item: string, index: number) => {
          const visible = item === undefined || isVisiblelabel.includes(item) ? 'flex' : 'none';
          let name: string;

          if (filters) {
            name = getStatusValues(item)[0]
          } else {
            name = item === undefined ? 'Другое' : item === 'availability' ? 'в наличии' : item;
          }

          return (
            <div
              className='charts__item' key={index} onClick={() => !typeCircle && handleClickOnLegend(item)}
              style={{ cursor: `${!typeCircle ? 'pointer' : 'grab'}`, display: `${visible}` }}>
              <div className='charts__color' style={{ backgroundColor: `${colorOptions[index]}` }} />
              <span className={`${isHiddenLabel.includes(item) ? 'span-hidden' : ''}`}>{name}</span>
            </div>)
        })}
      </div>
    </div>
  )
};

export default ScrollingLegend;